import React from "react";
import Heading from "../../../atoms/FormHeading";
import Form from "./Form";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Loader } from "lucide-react";

const ResetOrCreatePass = ({ type }) => {
  const [showForm, setShowForm] = useState(null);
  const [linkExpired, setLinkExpired] = useState(false);
  const location = useLocation();

  const params = new URLSearchParams(location.search);

  const userId = params.get("user_id");
  const token = params.get("token");
  const expiry = new Date(params.get("expiry"));
  const usertype = params.get('type');

  const currentTime = new Date();

  useEffect(() => {
    if (currentTime < expiry && !linkExpired) {
      setShowForm(true);
    } else {
      setShowForm(false);
    }
  }, [location]);

  return (
    <>
      <>
        {showForm == null ? (
          <Loader />
        ) : showForm ? (
          <>
            <Heading
              title={"New Password"}
              description={`Set the new password for your account so you can login and access all features.`}
              calledForm='auth'
            />
            <Form type={type} uid={userId} token={token} expiry={expiry} usertype={usertype}/> 
          </>
        ) : (
          <Heading
            title="Link Expired"
            description="This link has already been expired. Please generate a new link."
            calledForm='auth'
          />
        )}
      </>
    </>
  );
};

export default ResetOrCreatePass;
